module.exports = __webpack_public_path__ + "img/imgXharra-8.d8f7073b.png";